import * as moment from 'moment';

export function toNumberOrNull(value: any): number {
    const result = +value;

    if ((0 == result) || isNaN(result)) {
        return null;
    }

    return result;
}

export function toDateOrNull(date: any): Date {
    let momentDate = moment(date);

    if ((null != date) && momentDate.isValid()) {
        return momentDate.toDate();
    }

    return null;
}

export function toDateOrDefault(date: any): Date {
    let momentDate = moment(date);

    if ((null != date) && momentDate.isValid()) {
        return momentDate.toDate();
    } else {
        return moment().set({ year: 1, month: 0, date: 1 }).toDate();
    }
}

export function toDateStringOrNull(date: any): string {
    let momentDate = moment(date);

    if ((null != date) && momentDate.isValid()) {
        return momentDate.toJSON();
    }

    return null;
}

export function toStringOrNull(value: string): string {
    if (null == value) {
        return null;
    }

    let stringValue = value.toString();

    if ('' == stringValue.trim()) {
        return null;
    }

    return stringValue;
}
